var React = require('react');

function TestimonialsNavLeft (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2434_3830)","key":0},[React.createElement("circle",{"cx":"22","cy":"22","r":"21.5","transform":"rotate(-90 22 22)","stroke":"#E4032E","key":0}),React.createElement("path",{"d":"M18 22L24 28L25.41 26.59L20.83 22L25.41 17.41L24 16L18 22Z","fill":"#E4032E","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2434_3830"},React.createElement("rect",{"width":"44","height":"44","fill":"white","transform":"translate(0 44) rotate(-90)"})))]);
}

TestimonialsNavLeft.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = TestimonialsNavLeft;

TestimonialsNavLeft.default = TestimonialsNavLeft;
